import { useEffect, useState } from "react";
import { withIdentityPoolId } from "@aws/amazon-location-utilities-auth-helper";

const MAP_NAME = process.env.REACT_APP_MAP_NAME || "explore.map.Esri";
const IDENTITY_POOL_ID = process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID;
const REGION = "us-east-1";

export const MAP_STYLE_URL = `https://maps.geo.${REGION}.amazonaws.com/maps/v0/maps/${MAP_NAME}/style-descriptor`;

export function useMapAuth() {
  const [authOptions, setAuthOptions] = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function init() {
      try {
        const authHelper = await withIdentityPoolId(IDENTITY_POOL_ID);
        const options = authHelper.getMapAuthenticationOptions();

        // Fetch style descriptor with signed request and pass style JSON directly
        // to avoid unsigned initial style URL fetch issues in MapLibre.
        let styleJson = null;
        if (options?.transformRequest) {
          const req = options.transformRequest(MAP_STYLE_URL, "Style");
          const response = await fetch(req?.url || MAP_STYLE_URL, {
            headers: req?.headers || {},
          });
          if (response.ok) {
            styleJson = await response.json();
          }
        }

        if (!cancelled) {
          setAuthOptions({ ...options, styleJson });
        }
      } catch (err) {
        console.error("Failed to initialize map auth, falling back to public map style:", err);
        if (!cancelled) {
          // Keep UI functional even when AWS auth/style fetch fails.
          setAuthOptions({});
        }
      }
    }

    if (IDENTITY_POOL_ID) {
      init();
    }

    return () => {
      cancelled = true;
    };
  }, []);

  return authOptions;
}
